/** Modules de l'accueil — mêmes clés que backend APP_MODULES */
export const APP_MODULES = [
  { id: 'caisse', label: 'Caisse' },
  { id: 'honoraires', label: 'Honoraires' },
  { id: 'declarations', label: 'Déclarations' },
  { id: 'paie', label: 'Paie' },
];

export const ALL_MODULE_IDS = APP_MODULES.map((m) => m.id);

export function normalizeModules(raw, { defaultAll = true } = {}) {
  if (raw == null || raw === '') {
    return defaultAll ? [...ALL_MODULE_IDS] : [];
  }
  let list;
  if (Array.isArray(raw)) {
    list = raw;
  } else {
    const s = String(raw).trim();
    try {
      const parsed = JSON.parse(s);
      list = Array.isArray(parsed) ? parsed : s.split(/[,;|]/);
    } catch (_) {
      list = s.split(/[,;|]/);
    }
  }
  const set = new Set(
    list
      .map((m) => String(m || '').trim().toLowerCase())
      .filter(Boolean)
      .map((m) => (m === 'nh' || m === 'notes' ? 'honoraires' : m))
  );
  return ALL_MODULE_IDS.filter((m) => set.has(m));
}
